import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import makeGetIsUsingAddressLookup from '../../../selectors/DeliveryAddressSelectors/makeGetIsUsingAddressLookup';
import AddressLookupLazyLoader from './AddressLookupLazyLoader';

export function AddressLookupArbiter(props) {
  if (props.useAddressLookup) {
    return (
      <AddressLookupLazyLoader
        disabled={props.disabled}
        addressType={props.addressType}
        useNewDispatcherForBillingAddress={props.useNewDispatcherForBillingAddress}
      >
        {props.children}
      </AddressLookupLazyLoader>
    );
  }
  
  return props.children;
}

const mapStateToProps = ((state, ownProps) => ({
  useAddressLookup: !!makeGetIsUsingAddressLookup(ownProps.country)(state),
}));

AddressLookupArbiter.propTypes = {
  addressType: PropTypes.oneOf(['delivery', 'billing']).isRequired,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  useAddressLookup: PropTypes.bool.isRequired,
  useNewDispatcherForBillingAddress: PropTypes.bool,
};

export default connect(mapStateToProps)(AddressLookupArbiter);
